const DEFAULT_COLOR = 'white';

export default class Spinner {
  constructor({ color } = {}) {
    this.color = color || DEFAULT_COLOR;
  }

  build = () => {
    const spinner = document.createElement('div');
    const element = document.createElement('div');

    spinner.classList.add('spinner', `spinner--${this.color}`, 'js-spinner');
    element.classList.add('spinner__element');
    spinner.appendChild(element);

    return spinner;
  };
}
